import React from 'react'
import { DataGrid } from '../../datagrid/ResponsiveDataGrid';
import CustomToolbar from '../../datagrid/CustomToolbar';
import CustomLoadingOverlay from '../../datagrid/CustomLoadingOverlay';

const EmpChkList = ({
    apiRef,
    columns,
    rows,
    error,
    loading,
    columnVisibilityModel
}) => {

    return (
        <div style={{ display: 'flex', height: '500px' }}>
            <div style={{ flexGrow: 1 }}>
                <DataGrid
                    apiRef={apiRef}
                    rows={rows ? rows : []}
                    columns={columns}
                    loading={loading}
                    components={{
                        Toolbar: CustomToolbar,
                        LoadingOverlay: CustomLoadingOverlay,
                    }}
                    componentsProps={{
                        toolbar: { fileName: '사원 리스트' },
                    }}
                    checkboxSelection
                    disableSelectionOnClick
                    columnVisibilityModel={columnVisibilityModel? columnVisibilityModel: []}
                />
            </div>
        </div>
    );
};

export default EmpChkList